module.exports = __webpack_public_path__ + "media/components/lesson4/statics/sendMessage-8a1c98d7e48bbddc34783817998b6d4e.png";